export default [
  {
    path: 'applications',
    component: () =>
      import('@/views/applications/components/ApplicationsWrapper.vue'),
    children: [
      {
        path: '',
        name: 'applications',
        component: () => import('@/views/applications/AppSearch.vue'),
      },
      {
        path: '/applications/:appId',
        name: 'editapplication',
        component: () => import('@/views/applications/ManageApplication.vue'),
        props: true,
      },
    ],
  },
];
